<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const touchStartX = ref(0);
const touchEndX = ref(0);
const swipeDirection = ref('');

const handleTouchStart = (event) => {
  touchStartX.value = event.changedTouches[0].clientX;
};

const handleTouchEnd = (event) => {
  touchEndX.value = event.changedTouches[0].clientX;
  const swipeThreshold = 50;

  if (touchStartX.value - touchEndX.value > swipeThreshold) {
    swipeDirection.value = 'next';
    setTimeout(() => {
      router.push('/seventhIhram');
    }, 300);
  } else if (touchEndX.value - touchStartX.value > swipeThreshold) {
    swipeDirection.value = 'prev';
    setTimeout(() => {
      router.push('/fifthIhram');
    }, 300);
  }
};
</script>

<template>
  <section class="background" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
    <div class="container">
      <div class="header_block">
        <router-link to="">
          <img src="@/assets/img/icons/prev.svg">
        </router-link>
        <h2 class="title">Ихрам</h2>
        <div></div>
      </div>

      <div class="content">
        <div class="info">
          <p class="text">6. Находящимся в ихраме запрещено сва- таться или жениться. Также запрещены при- косновения к жене с вожделением и половая близость.</p>
          <i class="text text_green">На что указывает хадис Усмана (да будет доволен им Аллах!), что пророк сказал: </i>
          <i class="text text_green">«Находящийся в ихраме не женится, не женит и не сватается»</i>
          <p class="text_orange center">(Муслим)</p>
          <p class="text">7. Находящемуся в ихраме запрещено пользоваться каким-либо благовонием, наносимыми на тело или на одежду. Нет ничего предосудительного в том, что остается от запаха благовония, нанесенного на тело перед вхождением в состояние ихрама; если же благовоние попало на одежду, то его следует смыть.</p>
          <p class="text">8. Мужчине, находящемуся в ихраме, зап- рещено покрывать голову тюбетейкой, чалмой, накидкой и т.д. Если же это произошло по забывчивости или по нез- нанию, то паломник обязан, как только вспомнит или узнает об ошибке, снять голов- ной убор. искупительных действий от него не требуется.</p>
        </div>
        <div class="pagination">
          <span >{{ 6 }}/{{ 8 }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.content {
  position: relative;
}
.info {
  & .text:not(:first-child) {
    padding-top: 16px;
  }
}
.center {
  text-align: center;
  padding-top: 10px;
  font-style: italic;
}

.pagination {
  position: absolute;
  bottom: 27px;
  left: 50%;
  transform: translateX(-50%);
  color: #525D68;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
